import React from "react";
import "./modal.css";
import PropTypes from "prop-types";

export default class Modal extends React.Component {
  onClose = e => {
    this.props.onClose && this.props.onClose(e);
  };
  render() {
    if (!this.props.show) {
      return null;
    }

    return (
        <React.Fragment>
            <div className="lmp-modal-background"></div>
            <div className="lmp-modal" id="modal">
                <h2>
                  {(this.props.success !== undefined && this.props.success !== '') 
                    ? 'Success' 
                    : ((this.props.errors !== undefined && this.props.errors.length > 0) ? 'Error' : '')}
                </h2>
                <div className="content">
                    {this.props.children}
                    {(this.props.children !== undefined && this.props.children !== '') ? <br /> : ''}
                   
                   {(this.props.success !== undefined && this.props.success !== '') 
                    ? <React.Fragment>
                        {this.props.success}
                        <br />
                      </React.Fragment>
                    : (
                      (this.props.errors !== undefined && this.props.errors.length > 0) 
                      ? 
                        <ul>
                          {this.props.errors.map((error, index) => <li key={index}>{error}</li>)}
                        </ul> 
                      : ''
                    )}
                </div>
                <div className="actions button-container">
                <button className="square btn btn-primary btn-sm" onClick={this.onClose}>
                    Close
                </button>
                </div>
            </div>
        </React.Fragment>   );
  }
}
Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
};